import { useCallback, useMemo } from 'react';
import { TStepItem, TUseStepNavigation } from '~/components/StepNavigator/types.ts';
import { TApplicationStep } from '~/store/types.ts';

export const useStepNavigation = (
  current: number,
  setCurrent: (step: number) => void,
  applicationSteps: TApplicationStep[]
): TUseStepNavigation => {
  const next = useCallback(() => {
    setCurrent(current + 1);
  }, [current, setCurrent]);

  const prev = useCallback(() => {
    if (current) setCurrent(current - 1);
  }, [current, setCurrent]);

  const items: TStepItem[] = useMemo(
    () =>
      applicationSteps.map((item, index) => ({
        key: item.title || index.toString(),
        title: item.title || '',
        status:
          index === 0
            ? 'finish'
            : index === current
              ? 'process'
              : index < current
                ? 'finish'
                : 'wait',
      })) as TStepItem[],
    [applicationSteps, current]
  );

  return { next, prev, items };
};
